<template>
	<div class="message">
		<div class="message-icon-wrapper">
			<slot name="message-icon"></slot>
		</div>
		<div class="message-content-wrapper" @click="openMessage(message)">
			<div class="message-head">
				<div class="left-head-message">
					<h5
						v-if="!(message.sentByStudent || message.sentByUser)"
						name="message-sent-by"
						class="student-info"
					>
						{{ $t('na') }}
					</h5>
					<h5
						v-if="sender"
						class="student-info"
						name="sender-first-and-lastName"
					>
						{{ sender.firstName }}
						{{ sender.lastName }}
					</h5>
					<h5
						name="message-status"
						:class="`message-status ${message.messageStatus}`.toLowerCase()"
					>
						{{ $t(`messageStatus.${message.messageStatus.toLowerCase()}`) }}
					</h5>
				</div>
				<h5 class="right-head-message">
					<span class="message-date" name="message-date-created">
						{{ message.dateCreated | dateFormat }}
					</span>
					/
					<span class="message-time" name="message-date-created">
						{{ message.dateCreated | timeFormat }}
					</span>
				</h5>
			</div>
			<div
				v-if="message.text == null"
				class="message-content"
				name="message-content"
			>
				{{ $t('na') }}
			</div>
			<div v-else class="message-content">
				<div class="inner-container body-text-1" name="message-text">
					{{ message.text }}
				</div>
			</div>
		</div>
		<div class="message-delete" name="delete-message-button">
			<svgicon name="delete" @click="deleteMessage(message)"></svgicon>
		</div>
	</div>
</template>

<script>
import '@/components/icons/delete';
import '@/components/icons/read';

export default {
	props: {
		message: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {
			showDeleteMessageModal: false
		};
	},
	computed: {
		sender() {
			if (this.message) {
				if (this.message.sentByStudent) {
					return this.message.sentByStudent;
				}
				return this.message.sentByUser;
			}
			return null;
		}
	},
	methods: {
		openMessage(message) {
			this.$emit('openMessage', message);
		},
		deleteMessage(message) {
			this.$emit('deleteMessage', message);
		}
	}
};
</script>

<style lang="scss" scoped>
.message {
	font-family: 'RobotoRegular';
	font-size: 15px;
	letter-spacing: 0.5px;
	line-height: 23px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 17px 0px;

	.message-status {
		&.unread {
			color: $icon-unread;
		}
		&.read {
			color: $icon-read;
		}
		&.done {
			color: $icon-done;
		}
	}

	&:not(:first-child) {
		border-top: 1px solid $button-border;
	}

	.message-icon-wrapper {
		height: 56px;
		width: 56px;
		min-width: 56px;
		display: flex;
		align-items: center;
		justify-content: center;

		.svg-icon {
			height: 18.33px;
			width: 22px;
		}

		.svg-fill {
			&.read {
				fill: $icon-read;
				stroke: none;
			}
			&.unread {
				fill: $icon-unread;
				stroke: none;
			}
			&.done {
				fill: $icon-done;
				stroke: none;
			}
		}

		.message-status-icon {
			height: 48px;
			width: 48px;
			border-radius: 48px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	.message-content-wrapper {
		&:hover {
			cursor: pointer;
		}
		width: 90%;
		margin-right: 30px;
		.message-head {
			display: flex;
			justify-content: space-between;
			margin-bottom: 6px;

			.left-head-message {
				display: flex;

				.student-info {
					border-right: 1px solid $button-border;
					margin-right: 8px;
					padding-right: 8px;
					color: $font-dark;
				}
			}
			.right-head-message {
				color: $font-dark;
			}
		}
		.message-content {
			overflow: hidden;
			line-height: 23px;
			height: 46px;

			.inner-container {
				display: inline-block;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				word-break: break-all;
			}
		}
	}
	.message-delete {
		height: 56px;
		width: 56px;
		min-width: 56px;
		margin-right: 8px;
		display: flex;
		align-items: center;
		justify-content: center;

		svg {
			width: 24px;
			height: 24px;
			fill: $font-red-alert;
			@media (any-hover: hover) {
				&:hover {
					cursor: pointer;
					opacity: 0.5;
				}
			}
		}
	}
}
</style>
